import rimg from 'rimg-shopify';

export default class ProductSlideshow {
  constructor(component) {
    this.$images = $(component.el);
    this.$images.on('click', '.product-thumbnails-navigation-previous, .product-thumbnails-navigation-next', event => this.moveProductThumbnails(event));
    this.productThumbnailsWrapper = this.$images.find('.product-thumbnails-wrapper');
    this.productThumbnails = this.$images.find('.product-thumbnails');
    this.productThumbnail = this.$images.find('.product-thumbnail');

    rimg.watch(component.el[0]);

    component.el.on("rimg:load", () => this.setupProductSlideshow());

    if (this.productThumbnails.hasClass('has-side-scroll')) {
      this.setupProductSlideshow();

      $(window).resize(() => {
        this.setupProductSlideshow();
        this.productThumbnails.css({
          left: 0,
        });
      });
    }
  }

  setupProductSlideshow() {
    let tallestImageHeight = 0;
    let containerWidth = 0;

    this.productThumbnailPadding = parseInt(this.productThumbnail.css('padding-left'), 10) * 2;
    this.productThumbnail.width((this.productThumbnailsWrapper.width() / 4) - this.productThumbnailPadding);

    for (let i = 0; i < this.productThumbnail.length; i++) {
      const image = this.productThumbnail[i];
      const currentImageHeight = image.getBoundingClientRect().height;
      const currentImageWidth = image.getBoundingClientRect().width;

      if (currentImageHeight > tallestImageHeight) {
        tallestImageHeight = currentImageHeight;
      }

      containerWidth += currentImageWidth;
    }

    this.productThumbnailsWrapper.height(tallestImageHeight);
    this.productThumbnails.width(containerWidth);
  }

  moveProductThumbnails(e) {
    const containerWidth = this.productThumbnailsWrapper.width();
    const currentPosition = this.productThumbnails.position().left;

    if ($(e.currentTarget).hasClass('product-thumbnails-navigation-next') && ((currentPosition - containerWidth) > -(this.productThumbnails.outerWidth()))) {
      this.productThumbnails.css({
        left: currentPosition - containerWidth,
      });
    } else if ($(e.target).hasClass('product-thumbnails-navigation-previous') && (currentPosition < 0)) {
      this.productThumbnails.css({
        left: currentPosition + containerWidth,
      });
    }
  }
}
